import React from "react";
import AllRoutes from "./AllRoutes";

function App() {
  return (
    <>
      <AllRoutes />
    </>
  );
}

export default App;
